package net.frozenbit.games.soundgame.utils

import org.khronos.webgl.Int8Array

actual fun ByteArray.toJsArray(): Int8Array = unsafeCast<Int8Array>()
